import React, { useEffect, useState, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faUserShield, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { library } from "@fortawesome/fontawesome-svg-core";
import {Overlay, Popover, Row, Container} from 'react-bootstrap';
import Zoom from '../elements/Zoom'

library.add(faUser, faUserShield)
const UserIcon = ({ user, zoom, setZoom }) => {
  
  const [show, setShow] = useState(false)
  const [target, setTarget] = useState(null); 
  const [logoutHover, setLogoutHover] = useState(false)

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {

        if (event.target.innerText != user?.name?.split(" ").map((n)=>n[0]).join("") || event.target.className.includes("col-lg-2")) {
          setShow(false)
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, user]);
  }
   
  const handleClick = (e) => {

    if(e.target.className === "user-profile" || e.target.innerHTML === user?.name?.split(" ").map((n)=>n[0]).join("")) {
      setTarget(e.target);
      setShow(!show);
    }
  
  };

  const logOut = () => {
    localStorage.removeItem("token")
    window.location.reload()
  }

  
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  
  return (
      <div className="user-profile" onClick={(e) => handleClick(e)} >
        <p style={{marginTop: '4px'}}>{user?.name?.split(" ").map((n)=>n[0]).join("")}</p>
        <Overlay
      placement="bottom"
      show={show}
      target={target}
      transition={true}
      >
      <Popover className="user-popover" ref={wrapperRef}>
        <Container fluid style={{width: "100%"}}>
          <Row style={{padding: '4px'}}>
            <Container fluid>
              <Row style={{fontSize: '14px', fontWeight: '550'}}>
                {user?.name}   
              </Row>

              <Row style={{fontSize: '12px', fontWeight: '450'}}>
              {user?.email}
              </Row>
            </Container>

          </Row>
          <Row>
            <hr style={{backgroundColor: '#2963b9', height: '0.5px', padding: '0', margin: '0'}}></hr>
          </Row>

          
          <Zoom zoom={zoom} setZoom={setZoom}/>
        
          <Row className="logout-row" onClick={() => logOut()} onMouseEnter={() => setLogoutHover(true)} onMouseLeave={() => setLogoutHover(false)}>
            <FontAwesomeIcon icon={faSignOutAlt}
              size='1x' 
              className="all-font-icons logout-icon"
              style={{color: logoutHover && "#596470"}}
              />            
              Logout        
          </Row>
         </Container>
      </Popover>
      </Overlay>
      </div>

  

    )
}

export default UserIcon
